export default __webpack_public_path__ + "static/media/cloud-icon.162998fe.png";